module.exports = {"title":"Prisberegner","gb_for":"Gigabyte* koster","per_month":"pr. måned excl. moms.","gigs_over_xxx":"*hver Gigabyte over 500 Gigabytes koster DKK 1,- pr. stk. excl. moms."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/da.json
// module id = 18
// module chunks = 0